module.exports = __webpack_public_path__ + "static/media/icon_12.7428da7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_12.png
// module id = 1653
// module chunks = 1